export enum ChangesRecordAction {
  Creation = 'creation',
  Edition = 'edition',
}
